import { FileUploadBox } from "@/components/FileUploadBox";
import {
	Command,
	CommandItem,
	CommandList,
	CommandSeparator,
} from "@acme/ui/command";
import React, { useRef } from "react";
import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router";

export function TerminalUI() {
	const navigate = useNavigate();
	const [selectedIndex, setSelectedIndex] = useState(0);
	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		const handleFocus = () => {
			if (inputRef.current) {
				inputRef.current.focus();
			}
		};

		document.addEventListener("click", handleFocus);
		handleFocus();

		return () => {
			document.removeEventListener("click", handleFocus);
		};
	}, []);

	return (
		<>
			<div className="mb-4 text-white text-2xl">
				$ Welcome to <span className="font-bold text-primary">/run.zip/</span>
			</div>
			{/** here */}
			<FileUploadBox />
			<div className="mb-4 text-primary">Select an option:</div>
			<Command ref={inputRef}>
				<CommandList>
					<CommandItem onSelect={() => navigate("/template")}>
						New Project
					</CommandItem>
					<CommandItem onSelect={() => navigate("/join")}>
						Join Live Session
					</CommandItem>
					<CommandItem onSelect={() => navigate("/login")}>Login</CommandItem>
					<CommandSeparator />
					<CommandItem>About</CommandItem>
					<CommandItem>Exit</CommandItem>
				</CommandList>
			</Command>
			<div className="mt-4 text-gray-400">
				Use arrow keys to navigate, Enter to select
			</div>
		</>
	);
}
